<template>
	<component v-bind:is="iframeModal ? 'layout-blank' : 'layout-splash'">
		<form class="h-full flex flex-col">
			<div class="bg-green-500 px-6 py-4 text-white">
				<div class="flex justify-between items-baseline pr-4 mr-6">
					<h1 class="text-4xl font-bold">
						<span v-if="creating">
							<span v-if="form.trade == null">{{
								__("Create new offer")
							}}</span>
							<span v-else-if="form.trade == 'BUY'">{{
								__("Create buy offer")
							}}</span>
							<span v-else-if="form.trade == 'SELL'">{{
								__("Create sell offer")
							}}</span>
						</span>
						<span v-else>{{
							form.trade == "BUY" ? __("Edit buy offer") : __("Edit sell offer")
						}}</span>
					</h1>

					<div class="text-2xl font-semibold" v-if="step < 4">
						{{ __("Step") }} {{ step }}/{{ steps.length }}
					</div>
					<div class="text-2xl font-semibold" v-else-if="step == 4">
						{{ __("Review") }}
					</div>
				</div>

				<ui-button
					type="blank"
					class="absolute right-5 top-5"
					v-if="iframeModal"
					v-on:click="closeIframeModal()"
				>
					<ui-icon class="h-9 w-9 text-white" name="x" stroke-width="2" />
				</ui-button>
			</div>

			<!-- <ui-wizzard-progress
                :step="step"
                :steps="steps"
                v-on:change="tryGotoStep"
                :key="'PROGRESS_' + step"
            >
                <p>Das unverbindliche Erstellen eines Inserats verpflichtet noch nicht zum Kauf bzw. Verkauf. Ihr Interesse wird lediglich potenziellen Handelspartnern angezeigt. Der Kontraktabschluss erfolgt in einem separaten Schritt.</p>
            </ui-wizzard-progress>-->

			<ui-alert
				class="mt-4 md:hidden"
				type="error"
				message="Please check your submissions!"
				v-if="stepIsInvalid"
			/>

			<offer-edit-step1
				:offer="offer"
				:user="user"
				:form="form"
				:creating="creating"
				v-if="step == 1"
			/>

			<offer-edit-step2
				:offer="offer"
				:user="user"
				:form="form"
				:activeFutures="activeFutures"
				v-if="step == 2"
			/>

			<offer-edit-step3
				:offer="offer"
				:user="user"
				:form="form"
				v-if="step == 3"
			/>

			<offer-edit-step4
				:offer="offer"
				:user="user"
				:form="form"
				:activeFutures="activeFutures"
				v-if="step == 4"
			/>

			<div class="bg-gray-100 px-6 pt-4 pb-6">
				<p class="text-gray-500 text-sm">
					{{ __("non_binding_advertisement_creation") }}
				</p>

				<div class="flex justify-between mt-4">
					<ui-button
						type="secondary"
						v-if="step > 1"
						v-on:click="
							() => {
								step--;
								checkPriceType();
							}
						"
						label="Back"
					/>

					<ui-button
						class="ml-auto"
						v-if="step <= 3"
						v-on:click="
							() => {
								tryGotoStep(step + 1);
								checkPriceType();
							}
						"
						label="Next"
					/>
					<ui-button
						class="ml-auto"
						v-else-if="!formIsInvalid"
						:disabled="submitButtonDisabled"
						v-on:click="submitForm()"
						label="Save"
					/>
				</div>
			</div>
		</form>
	</component>
</template>

<script>
import UiWizzard from "../components/Ui/Wizzard.vue";
export default {
	mixins: [UiWizzard],
	props: {
		offer: {
			type: Object,
			required: true,
		},
		user: {
			type: Object,
			required: true,
		},
		userUploads: {
			type: Array,
			required: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
		iframeModal: {
			type: Boolean,
			default: false,
		},
		creating: {
			type: Boolean,
			default: false,
		},
		duplicating: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			form: Vue.observable(this.$inertia.form(this.offer)),
			step: 1,
			steps: [
				{ name: "Step 1", href: "#" },
				{ name: "Step 2", href: "#" },
				{ name: "Step 3", href: "#" },
			],
			priceTypeIsNone: false,
		};
	},
	computed: {
		hasErrors() {
			return Object.keys(this.form.errors).length > 0;
		},
	},
	methods: {
		onSuccess() {
			if (this.creating) {
				if (this.form.trade == "BUY") {
					console.log("ANALYTICS_EMIT_BUY_SUBMITTED");
					this.$bus.$emit("analytics:created-buy");
				} else if (this.form.trade == "SELL") {
					console.log("ANALYTICS_EMIT_SELL_SUBMITTED");
					this.$bus.$emit("analytics:created-sell");
				}
			}
		},
		checkPriceType() {
			if (
				this.step == 1 &&
				this.form.qty.mt == null &&
				this.form.trade == "SELL"
			) {
				// set pseudo price type the first time the form gets called
				this.form.price.type = "NONE";
			} else if (this.step == 2) {
				// show pseudo price type in price form
				if (this.priceTypeIsNone) {
					this.form.price.type = "NONE";
					this.priceTypeIsNone = false;
				}
			}
		},
	},
};
</script>
